import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import sanitizeHTML from "../../utils/sanitize";
import { IoMdShare } from "react-icons/io";

export default function Detail() {
    const [data, setData] = useState<any>(null);
    const navigate = useNavigate();

    const getData = async () => {
        const title = window.location.pathname.split("/").pop();

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/product/get-by-name?title=${title}`
            );

            if (response.data && response.data.data) {
                return setData(response.data.data);
            } else {
                navigate("/");
            }
        } catch (error) {
            console.log(error);
            navigate("/");
        }
    };

    const handleCopyLink = () => {
        const linkToCopy = `${window.location.origin}${window.location.pathname}`;

        navigator.clipboard.writeText(linkToCopy)
            .then(() => alert("URL berhasil disalin!"))
            .catch((error) => console.error("Gagal menyalin URL:", error));
    };

    useEffect(() => {
        getData();
    }, []);

    if (data === null) {
        return <div className="text-center mt-28">Loading...</div>;
    }

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-1 p-4 md:p-5 lg:px-16">
            <div className="flex justify-center mt-8 mb-8">
                <LazyLoadImage
                    src={process.env.REACT_APP_API_ENDPOINT + '/product/getimg/' + data.img_product}
                    alt="produk-1"
                    effect="blur"
                    className="w-full h-auto"
                    wrapperProps={{
                        style: { transitionDelay: '1s' },
                    }}
                />
            </div>
            <div className="flex mt-9">
                <div
                    className="text-bprYellow font-poppinsBold text-xl"
                    dangerouslySetInnerHTML={{
                        __html: data.title ? data.title.toUpperCase() : "",
                    }}
                ></div>
                <div className="ml-auto flex items-center space-x-3">
                    <span className="font-poppinsRegular text-bprDarkBlue text-[12px]">
                        {new Intl.DateTimeFormat("id-ID", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        }).format(new Date(data.created_at))}
                    </span>
                    <IoMdShare
                        className="text-2xl cursor-pointer text-bprDarkBlue hover:text-blue-500"
                        title="Share"
                        onClick={() => handleCopyLink()}
                    />
                </div>
            </div>
            <div className="mt-10 mb-10">
                <article className="prose w-full max-w-none text-[#627D92] font-poppinsRegular text-lg">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: data.description,
                        }}
                    ></div>
                </article>
            </div>
        </div>
    );
}
